module.exports = __webpack_public_path__ + "img/coworking_colour.07db654d.webp";